import { ACTIONS } from '../config/constants';

export default (state = null, action) => {
  switch (action.type) {
    case ACTIONS.TYPES.APP.INIT_SUCCESS: {
      return action.app;
    }
    case ACTIONS.TYPES.APP.UPDATE_APP: {
      return action.app;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/app.reducer.js